import { css } from '@adornis/chemistry/directives/css.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { html } from 'lit';

export const InternalInfoBanner = () => {
  const theme = DesignSystem.currentTheme.getValue();
  return html`
    <tr-flex
      ${css({
        padding: theme.spacing.sm,
        background: theme.colors.tone.error!.shade(100),
        color: theme.colors.tone.error,
      })}
    >
      <tr-text><b>Info: </b> das Uniklinikum ist keine interne Abteilung!</tr-text>
    </tr-flex>
  `;
};
